module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', {
    staticClass: "p-datatable-tbody"
  }, _vm._l((_vm.rows), function(n) {
    return _c('tr', {
      key: n
    }, _vm._l((_vm.columns), function(col, i) {
      return _c('td', {
        key: col.columnKey || col.field || i
      }, [_c('DTColumnSlot', {
        attrs: {
          "column": col,
          "index": i,
          "type": "loading"
        }
      })], 1)
    }), 0)
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-634187a6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/primevue/datatable/TableLoadingBody.vue
// module id = 2272
// module chunks = 0